import { z } from 'zod';

export const zodInvoiceForwardingsListSearchParamsSchema = z.object({
  isActive: z.boolean().optional().prefault(true),
  page: z.number().nonnegative().optional().prefault(0).catch(0),
  searchString: z.string().trim().optional().prefault(''),
});
